import React, {Component} from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from "moment";
import fileDownload from 'js-file-download';

import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';

import * as ReactBootStrap from 'react-bootstrap';
import EstadoVacio from '../components/EstadoVacio';
import InformeConsultas from '../components/InformeConsultas';
import CalificacionEstrellas from '../components/CalificacionEstrellas';
import BtnVer from '../components/BtnVer';
import Buscar from '../tools/images/Buscar';
import Info from '../tools/images/Info';
import '../tools/css/Home.css';
import '../tools/css/Consultas_programada.css';

import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

const ApiURL=process.env.REACT_APP_API_URL;

var buscar_consulta='';
var mensaje='';
var id_consulta=0;


class Consultas_programada extends Component {

  informeRef = React.createRef();

  constructor()
    {
     super()
      this.state={
        Consulta: [],
        Pager_Consultas: [],
        pager_infoconsultas:'',
        buscar_consultas:'',
        loading: false,
        loading_recurso:false,
        loading_button: true,
        active_button: true,
        exportandoExcel:false,
        Historia:[],
        diagnostico:[],
        trazabilidad:{
          asignada:true,
          finalizada:false,
          conHistoria:false,
          conCargos:false,
          requiereCargo:false,
          facturada:false,
          cargandoCargos:false
        },
        form:{
          idconsulta:'',
          nom_paciente:'',
          nom2_paciente:'',
          apell1_paciente:'',
          apell2_paciente:'',
          id_paciente:'',
          eps:'',
          nom_medico:'',
          nom2_medico:'',
          apell1_medico:'',
          apell2_medico:'',
          eps:'',
          fecha_consulta:new Date,           
          }
      }
    }


    handleModalconsultashow()
    {      
      $('#modal-consulta').modal('show'); // <- to show modal editar contrato       
    }

    handleModalarecurdoshow()
    {      
      $('#modal-loader').modal('show'); // <- to show modal editar contrato       
    }

    handleModalarecurdodrop()
    {      
      $('#modal-loader').modal('hide'); // <- to show modal editar contrato       
    }

    modal_informacionpcte(){
     
      $('#modal-infopcte').modal('show');
     
    }

    empty_page_hide(){

      $('#tabla1').hide();     
      $('#empty_page').hide();
      $('#text_page').hide();
    }
     

    
    BuscarConsulta = (bc) =>{
      this.setState({buscar_consultas:bc.target.value})
      console.log(bc.target.value)
      buscar_consulta=(bc.target.value)
      this.searchDataconsulta(buscar_consulta)
     
    }

    handlePagependientes = (e) => {
      const selectedPage = e.selected;
      const offset = selectedPage * this.state.perPage;

      this.setState({
          currentPage: selectedPage,
          offset: offset
      }, () => {
          this.loadMoreDatapedientes()
      });

  };

  loadMoreDatapedientes() {
    const data = this.state.orgtableData;
    
    const slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
    this.setState({
      pageCount: Math.ceil(data.length / this.state.perPage),
      Consulta:slice
    })
  
    }

    componentDidMount(){

      $('[data-toggle="tooltip"]').tooltip()
      this.ListarConsultas();

    }

    ListarConsultas(){
      this.empty_page_hide();

      this.setState({ loading: this.state.loading = false })

      axios.get(ApiURL+"/api/Consultations/ListExternalConsultation")
      .then((response) => {
        console.log(response);
        
        this.setState({Consulta: response.data.data})  
        this.setState({Pager_Consultas: response.data.pager.items})
        this.setState({pager_infoconsultas: response.data.pager.showData}) 

        if(this.state.Consulta.length==0){
          $('#tabla1').hide();
          $('#empty_page').show();
          $('#text_page').show();
        }else{
          $('#tabla1').show();
          $('#empty_page').hide();
          $('#text_page').hide();
        }
        
        this.setState({ loading: this.state.loading = true })
      })
      .catch((error) => {
        console.log(error);
      }) 

    }

    loadMoreDataconsultas(page_consulta) {
      var page=page_consulta.pagina
      this.setState({ loading: this.state.loading = false })
      
      axios.get(ApiURL+"/api/Consultations/ListExternalConsultation?numeropagina="+page)
      .then((response) => {
        console.log(response);

        this.setState({Consulta: response.data.data})  
        this.setState({Pager_Consultas: response.data.pager.items})
        this.setState({pager_infoconsultas: response.data.pager.showData}) 
      
        this.setState({ loading: this.state.loading = true })
      })
      .catch((error) => {
        console.log(error);
      })
    
      }

      searchDataconsulta(buscar_consulta) {

        this.setState({ loading: this.state.loading = false })
        
        axios.get(ApiURL+"/api/Consultations/ListExternalConsultation?texto="+buscar_consulta)
        .then((response) => {
          console.log(response);
  
          this.setState({Consulta: response.data.data})  
          this.setState({Pager_Consultas: response.data.pager.items})
          this.setState({pager_infoconsultas: response.data.pager.showData}) 
        
          this.setState({ loading: this.state.loading = true })
        })
        .catch((error) => {
          console.log(error);
        })

        }

        // Exporta a Excel (.xls) TODAS las consultas que coincidan con la búsqueda
        // activa (no solo la página cargada en pantalla): recorre ListExternalConsultation
        // página por página hasta que una página vuelva vacía. No incluye el botón Ver.
        exportarExcelConsultas=()=>{
          this.setState({ exportandoExcel:true })
          this.recolectarConsultasParaExportar(1, [])
        }

        recolectarConsultasParaExportar=(pagina, acumulado)=>{
          const LIMITE_PAGINAS = 500 // salvavidas ante un backend que nunca devuelva página vacía
          const busqueda = this.state.buscar_consultas
          const url = ApiURL+"/api/Consultations/ListExternalConsultation?numeropagina="+pagina + (busqueda ? "&texto="+busqueda : "")

          axios.get(url)
          .then((response) => {
            console.log(response);
            const datos = (response.data && response.data.data) || []
            const acumuladoNuevo = acumulado.concat(datos)

            if(datos.length>0 && pagina<LIMITE_PAGINAS){
              this.recolectarConsultasParaExportar(pagina+1, acumuladoNuevo)
            }else{
              this.generarArchivoExcelConsultas(acumuladoNuevo)
            }
          })
          .catch((error) => {
            console.log(error);
            this.setState({ exportandoExcel:false })
            store.addNotification({
              title: 'Atención',
              message: "Ocurrió un error exportando las consultas",
              type: 'danger',
              container: 'top-right',
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: { duration: 6000, showIcon:true }
            })
          })
        }

        generarArchivoExcelConsultas=(todasLasConsultas)=>{

          this.setState({ exportandoExcel:false })

          const capitalizar = (texto) => texto ? texto.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''
          const escapar = (valor) => (valor===null || valor===undefined) ? '' : String(valor).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')

          const filas = todasLasConsultas.filter((consultas) => consultas.appointmentId!==null && consultas.appointmentId!==undefined)

          if(filas.length===0){
            store.addNotification({
              title: 'Atención',
              message: "No hay consultas para exportar",
              type: 'danger',
              container: 'top-right',
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: { duration: 6000, showIcon:true }
            })
            return
          }

          const encabezados = ['N°','N° cita','Paciente','Identificación','Entidad','Profesional','Fecha Consulta','Estado','Calificación']

          const filasHtml = filas.map((consultas) => {

            const paciente = capitalizar(consultas.patient.user.name1) + ' ' + capitalizar(consultas.patient.user.name2) + ' ' + capitalizar(consultas.patient.user.lastname1) + ' ' + capitalizar(consultas.patient.user.lastname2)
            const identificacion = consultas.patient.user.typeId + ' - ' + consultas.patient.user.identification
            const entidad = consultas.patient.eps.name ? capitalizar(consultas.patient.eps.name.trim().toLowerCase()) : ''
            const profesional = capitalizar(consultas.professional.user.name1) + ' ' + capitalizar(consultas.professional.user.name2) + ' ' + capitalizar(consultas.professional.user.lastname1) + ' ' + capitalizar(consultas.professional.user.lastname2)
            const fecha = consultas.date ? moment(consultas.date).format('YYYY/MM/DD HH:mm') : ''
            const estado = consultas.status ? capitalizar(consultas.status) : ''
            const calificacion = (consultas.score===null || consultas.score===undefined || consultas.score==='') ? 'Sin calificar' : consultas.score

            return '<tr>'
              + '<td>' + escapar(consultas.id) + '</td>'
              + '<td>' + escapar(consultas.appointmentId) + '</td>'
              + '<td>' + escapar(paciente.replace(/\s+/g,' ').trim()) + '</td>'
              + '<td>' + escapar(identificacion) + '</td>'
              + '<td>' + escapar(entidad) + '</td>'
              + '<td>' + escapar(profesional.replace(/\s+/g,' ').trim()) + '</td>'
              + '<td>' + escapar(fecha) + '</td>'
              + '<td>' + escapar(estado) + '</td>'
              + '<td>' + escapar(calificacion) + '</td>'
              + '</tr>'

          }).join('')

          const html = '<html><head><meta charset="UTF-8"></head><body>'
            + '<table border="1"><thead><tr>' + encabezados.map((h) => '<th>' + h + '</th>').join('') + '</tr></thead>'
            + '<tbody>' + filasHtml + '</tbody></table>'
            + '</body></html>'

          fileDownload(html, 'consultas_realizadas_' + moment().format('YYYYMMDD_HHmm') + '.xls', 'application/vnd.ms-excel')

        }


        seleccionarconsulta=(consultas)=>{

          id_consulta=consultas.id
          this.setState({ Historia:consultas.consultationData })
          //this.saverecurso(id_consulta);

          const finalizada = consultas.status==='finalizada'
          const conHistoria = finalizada && (consultas.consultationData!==null && consultas.consultationData!==undefined)

          this.setState({
            trazabilidad:{
              asignada:true,
              finalizada:finalizada,
              conHistoria:conHistoria,
              conCargos:false,
              requiereCargo:false,
              facturada:false,
              cargandoCargos:finalizada
            }
          })

          if(finalizada){
            this.cargarCargosConsulta(consultas.appointmentId)
          }

          this.setState({
              form:{
              idconsulta:consultas.id, 
              id_paciente:consultas.patient.user.typeId +'-'+ consultas.patient.user.identification,
              nom_paciente: consultas.patient.user.name1 ? consultas.patient.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              nom2_paciente: consultas.patient.user.name2 ? consultas.patient.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell1_paciente: consultas.patient.user.lastname1 ? consultas.patient.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell2_paciente: consultas.patient.user.lastname2 ? consultas.patient.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              eps:consultas.patient.eps.name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
              nom_medico: consultas.professional.user.name1 ? consultas.professional.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))  : '',  
              nom2_medico: consultas.professional.user.name2 ? consultas.professional.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',               
              apell1_medico : consultas.professional.user.lastname1 ? consultas.professional.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell2_medico : consultas.professional.user.lastname2 ? consultas.professional.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''
             
            }
          })
          //var  dato  = solicitud.user.identification;
          //alert(Historia);
        }

        // Estado "Con cargos realizados" de la trazabilidad: PendingAppointments lista
        // las citas que TODAVÍA tienen un cargo pendiente por realizar. Si el
        // appointmentId de la consulta NO aparece ahí, el cargo ya se hizo (estado
        // cumplido). Si SÍ aparece, el cargo está pendiente: se marca ese paso en
        // naranja con la acción "Realizar cargo" hacia /facturacion.
        // El endpoint pagina igual que ListExternalConsultation (?numeropagina=),
        // así que hay que recorrer todas las páginas hasta encontrar el appointmentId
        // o hasta que una página vuelva vacía (ahí se acabó el listado).
        cargarCargosConsulta=(appointmentId)=>{
          this.buscarAppointmentEnPendientes(appointmentId, 1)
        }

        buscarAppointmentEnPendientes=(appointmentId, pagina)=>{
          const LIMITE_PAGINAS = 500 // salvavidas ante un backend que nunca devuelva página vacía

          axios.get(ApiURL+"/api/Invoices/PendingAppointments?numeropagina="+pagina)
          .then((response) => {
            console.log(response);
            const items = (response.data && response.data.data) || response.data || []
            const encontrado = Array.isArray(items) && items.some((item) => item.appointmentId === appointmentId)

            if(encontrado){
              this.setState((previo) => ({ trazabilidad: { ...previo.trazabilidad, conCargos: false, requiereCargo: true, cargandoCargos: false } }))
              return
            }

            if(Array.isArray(items) && items.length > 0 && pagina < LIMITE_PAGINAS){
              this.buscarAppointmentEnPendientes(appointmentId, pagina + 1)
            }else{
              this.setState((previo) => ({ trazabilidad: { ...previo.trazabilidad, conCargos: true, requiereCargo: false, cargandoCargos: false } }))
            }
          })
          .catch((error) => {
            console.log(error);
            this.setState((previo) => ({ trazabilidad: { ...previo.trazabilidad, cargandoCargos: false } }))
          })
        }


        seleccionarinfo_pcte=(consultas)=>{
             
            
              this.setState({
                form:{
                  
                  fecha_naci:moment(consultas.patient.user.birthday).format("DD/MM/YYYY"),
                  edad_pcte:moment(consultas.patient.user.birthday).toNow(true),
                  genero_pcte:consultas.patient.user.gender,
                  dir_pcte:consultas.patient.user.address,
                  tel_pcte:consultas.patient.user.phone,
                  //municipio_pcte:cita_proce.patient.user.municipality.nombre ? cita_proce.patient.user.municipality.nombre.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
                  //departamento_pct: cita_proce.patient.user.department.nombre ? cita_proce.patient.user.department.nombre.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
                  responsable_pcte:consultas.patient.user.personInCharge,
                  telresponsable_pcte:consultas.patient.user.phone,
                  parentescoresp_pcte:consultas.patient.user.relationshipPerson,
                  eps_pcte:consultas.patient.eps.name,
                  //regimen_pcte:cita_proce.patient.regimen.nombre ? cita_proce.patient.regimen.nombre : '',
                  email_pcte:consultas.patient.user.email
                  
                }
              })
              //var  dato  = solicitud.user.identification;
              //alert(cita_proce.fecha);
        
             
            }





        saverecurso=async()=>{
        

          this.setState({ loading_recurso: this.state.loading_recurso = false })
          $('#modal-loader').modal('show') // <- to show modal descarga video
          $('#modal-consulta').modal('hide') // <- to show modal descarga video

          await axios.get(ApiURL+"/api/Consultations/GetVideoResource/"+id_consulta,{            
            
            responseType:'blob'

          })  
      
          .then(response=>{
            
            fileDownload(response.data,'Consultation-'+id_consulta+'.mp4')
            
            store.addNotification({
              title: 'Mensaje',
              message: "El video ha sido descargado",
              type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })

            this.setState({ loading_recurso: this.state.loading_recurso = true })
            this.handleModalarecurdodrop();

      
            
          })
          .catch((error)=>{

            if (error.response) {

              console.log(error.response);
              mensaje=error.message;                    
  
              store.addNotification({
                title: 'Atención',
                message: "El video se está generando, intente la descarga más tarde",
                type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })            
              
              this.setState({ loading_recurso: this.state.loading_recurso = true })
              this.handleModalrecursodrop(); 
    
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
            //console.log(error.config);            
            
        })
      
      
       }


      descargar_consulta=async()=>{        

        this.setState({ loading_button: this.state.loading_button = false })
        this.setState({ active_button: this.state.active_button = false })
        //$('#modal-loader').modal('show') // <- to show modal descarga video
        //$('#modal-consulta').modal('hide') // <- to show modal descarga video

        await axios.get(ApiURL+"/api/Consultations/PrintConsultation/"+id_consulta,{            
          
          responseType:'blob'

        })  
    
        .then(response=>{
          
          fileDownload(response.data,'Consultation-'+id_consulta+'.pdf')
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const objectUrl = window.URL.createObjectURL(blob)
          window.open(objectUrl)
          
          store.addNotification({
            title: 'Mensaje',
            message: "El documento ha sido descargado",
            type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })

          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
          //this.handleModalarecurdodrop();   
          
        })
        .catch((error)=>{

          if (error.response) {

            console.log(error.response);
            mensaje=error.message;                    

            store.addNotification({
              title: 'Atención',
              message: "No se encontró información",
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })            
            
            this.setState({ loading_button: this.state.loading_button = true })
            this.setState({ active_button: this.state.active_button = true })
            //this.handleModalrecursodrop(); 
  
          } else if (error.request) {
              /*
               * The request was made but no response was received, `error.request`
               * is an instance of XMLHttpRequest in the browser and an instance
               * of http.ClientRequest in Node.js
               */
              console.log(error.request);
          } else {
              // Something happened in setting up the request and triggered an Error
              console.log('Error', error.message);
          }
          //console.log(error.config);            
          
      })    
    
    }


      descargar_formula=async()=>{        

      this.setState({ loading_button: this.state.loading_button = false })
      this.setState({ active_button: this.state.active_button = false })
      //$('#modal-loader').modal('show') // <- to show modal descarga video
      //$('#modal-consulta').modal('hide') // <- to show modal descarga video

      await axios.get(ApiURL+"/api/Consultations/PrintMedicalPrescription/"+id_consulta,{            
        
        responseType:'blob'

      })  
  
      .then(response=>{
        
        fileDownload(response.data,'Formula-'+id_consulta+'.pdf')
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const objectUrl = window.URL.createObjectURL(blob)
        window.open(objectUrl)
         
        
        store.addNotification({
          title: 'Mensaje',
          message: "El documento ha sido descargado",
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        }) 
        
        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })
        //$('#modal-loader').modal('hide');
        
      })
      .catch((error)=>{

        if (error.response) {

        console.log(error.response);
        mensaje=error.message;                    

        store.addNotification({
          title: 'Atención',
          message: "No se encontró información",
          type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        })            
        
        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })
        //this.handleModalrecursodrop(); 

      } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
      } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
      }
      //console.log(error.config);                       
        
    })  
  
      }


      descargar_orden=async()=>{        

    this.setState({ loading_button: this.state.loading_button = false })
    this.setState({ active_button: this.state.active_button = false })
    //$('#modal-loader').modal('show') // <- to show modal descarga video
    //$('#modal-consulta').modal('hide') // <- to show modal descarga video

    await axios.get(ApiURL+"/api/Consultations/PrintMedicalOrder/"+id_consulta,{            
      
      responseType:'blob'

    })  

    .then(response=>{
      
      fileDownload(response.data,'Orden-'+id_consulta+'.pdf')
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const objectUrl = window.URL.createObjectURL(blob)
      window.open(objectUrl)
 
      
      store.addNotification({
        title: 'Mensaje',
        message: "El documento ha sido descargado",
        type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
        container: 'top-right',                // where to position the notifications
        animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
        animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
        dismiss: {
          duration: 10000,
          showIcon:true
        }
      })   
      
      this.setState({ loading_button: this.state.loading_button = true })
      this.setState({ active_button: this.state.active_button = true })
      //$('#modal-loader').modal('hide');
      
    })
    .catch((error)=>{

      if (error.response) {

      console.log(error.response);
      mensaje=error.message;                    

      store.addNotification({
        title: 'Atención',
        message: "No se encontró información",
        type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
        container: 'top-right',                // where to position the notifications
        animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
        animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
        dismiss: {
          duration: 10000,
          showIcon:true
        }
      })            
      
      this.setState({ loading_button: this.state.loading_button = true })
      this.setState({ active_button: this.state.active_button = true })

    } else if (error.request) {
        /*
         * The request was made but no response was received, `error.request`
         * is an instance of XMLHttpRequest in the browser and an instance
         * of http.ClientRequest in Node.js
         */
        console.log(error.request);
    } else {
        // Something happened in setting up the request and triggered an Error
        console.log('Error', error.message);
    }
    //console.log(error.config);                       
      
  })


    }

  handleModalnewhc()
  {
   
   $("#id_espe").val($('#id_espe>option:first').val());
   $("#tipo_campo").val($('#tipo_campo>option:first').val());
   $('#row_textarea').hide();
   $('#row_input').hide();
   $('#row_select').hide();
   $('#row_date').hide();
   
   $('#modal-crearhc').modal('show'); // <- to show modal crear sede 
   
  }

  GetTipocampo = (t) =>{
    
  console.log(t.target.value)
  var tipo=(t.target.value)

  //alert(tipo);

  if(tipo=="1"){
    $('#row_input').show();
    $('#row_select').hide();
    $('#row_date').hide();
    $('#row_textarea').hide();
  }else{
    
    if (tipo=="2"){
      $('#row_select').show();
      $('#row_textarea').hide();
      $('#row_input').hide();
      $('#row_date').hide();

    }else{
      if (tipo=="3"){
        $('#row_textarea').show();
        $('#row_input').hide();
        $('#row_select').hide();
        $('#row_date').hide();
      }else{

        if (tipo=="4"){
          $('#row_date').show();
          $('#row_textarea').hide();
          $('#row_input').hide();
          $('#row_select').hide();
        }

      }
    }
  }

  }

    render(){
      const {form, trazabilidad} = this.state;

     return (

     
        <div className="content-wrapper">


            <div className="col-12 col-sm-12">

                <div className="row">
          
                    <div className="col-sm-12">
                    <br></br>
                       <div className="text-center" id="title"> <h6> <b> REPORTE GENERAL DE CONSULTAS </b>  </h6> </div>
          
                    </div>  

                    {/*<div  className="col-sm-2 col-md-offset-2">
                          <br></br>
                             <button id="btn_crear" className="btn btn-edit" onClick={()=>{this.handleModalnewhc()}}> Crear formato
                                <svg width="20" height="15" viewBox="3 3 10 10" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                </svg> 
                             </button>        
                    </div>*/}        
                   
          
                </div>

                <div className="card card-primary card-outline card-tabs">

                    <div className="card-header p-0 pt-1 border-bottom-0">
                        <ul className="nav nav-tabs" id="consultas-tabs-tab" role="tablist">
                          <li className="nav-item">
                            <a className="nav-link active" id="consultas-tabs-realizadas-tab" data-toggle="pill" href="#consultas-tabs-realizadas" role="tab" aria-controls="consultas-tabs-realizadas" aria-selected="true"><i className="fas fa-list-ul"></i> Consultas realizadas</a>
                          </li>
                          <li className="nav-item">
                            <a className="nav-link" id="consultas-tabs-informes-tab" data-toggle="pill" href="#consultas-tabs-informes" role="tab" aria-controls="consultas-tabs-informes" aria-selected="false" onClick={()=>{this.informeRef.current && this.informeRef.current.cargarInforme()}}><i className="fas fa-chart-pie"></i> Informes</a>
                          </li>
                        </ul>
                    </div>

                    <div className="card-body">

                      <div className="tab-content" id="consultas-tabs-tabContent">

                        <div className="tab-pane fade show active" id="consultas-tabs-realizadas" role="tabpanel" aria-labelledby="consultas-tabs-realizadas-tab">

                          <div class="d-flex justify-content-center">

                              {this.state.loading?false: <ReactBootStrap.Spinner animation="border" />}

                          </div>

                          <div className="consultas-panel" id="tabla1">

                              <div className="row consultas-toolbar">

                                    <div className="col-sm-3">
                                          <div className="input-group input-group-sm mb-3 mr-sm-2">
                                             <div className="input-group-prepend">
                                               <div className="input-group-text"><Buscar/></div>
                                             </div>
                                             <input type="search" className="form-control" placeholder="Buscar" name="buscar_consultas" onChange={this.BuscarConsulta}/>
                                          </div>
                                    </div>

                                    <div className="col-sm-9 consultas-toolbar__acciones">
                                          <button type="button" className="btn consultas-btn-exportar" disabled={this.state.exportandoExcel} onClick={()=> this.exportarExcelConsultas()}>
                                            {this.state.exportandoExcel ? <i className="fas fa-circle-notch fa-spin"></i> : <i className="fas fa-file-excel"></i>}
                                            {this.state.exportandoExcel ? ' Exportando...' : ' Exportar Excel'}
                                          </button>
                                    </div>

                              </div>

                          <div className="consultas-table-wrap">
                                <table id="tabla_solicitudes" className="table table-bordered table-striped consultas-table">
                                  <thead>
                                    <tr>
                                      <th>N° Consulta</th>
                                      <th>N° cita</th>                                      
                                      <th>Paciente</th>
                                      <th>Identificación</th>
                                      <th>Entidad</th>
                                      <th>Profesional</th>
                                      <th>Fecha Consulta</th>
                                      <th>Calificación</th>
                                      <th>Estado</th>
                                      <th>Ver</th>          
                                    </tr>
                                  </thead>
                            
                                  <tbody>
                                                  
                                      {this.state.Consulta.map(consultas=>{
                                        var tipo_consulta=consultas.appointmentId
                                        var estado=consultas.status
                                        if(tipo_consulta!==null){

                                          var puedeVerConsulta=estado=='finalizada'
                                          estado=(
                                            <td onClick={puedeVerConsulta ? ()=>{this.handleModalconsultashow();this.seleccionarconsulta(consultas)} : undefined}>
                                              <BtnVer deshabilitado={!puedeVerConsulta} titulo={puedeVerConsulta ? 'Ver detalle de la consulta' : 'Disponible cuando la consulta esté finalizada'} />
                                            </td>
                                          )

                                        
                                        return(      
                                        
                                        <tr>          
                                          <td>{consultas.id}</td>
                                          <td>{consultas.appointmentId}</td>              
                                          <td>{consultas.patient.user.name1 ? (consultas.patient.user.name1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} {consultas.patient.user.name2 ? (consultas.patient.user.name2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} { consultas.patient.user.lastname1 ? (consultas.patient.user.lastname1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} {consultas.patient.user.lastname2 ? (consultas.patient.user.lastname2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} <a data-toggle="tooltip" data-placement="top" title="Más información del paciente."  id="btn-registrarse" href="#" onClick={()=>{this.seleccionarinfo_pcte(consultas);this.modal_informacionpcte()}} > <spam  > <Info/> </spam> </a> </td>
                                          <td>{consultas.patient.user.typeId} - {consultas.patient.user.identification}</td>
                                          <td>{consultas.patient.eps.name ? (consultas.patient.eps.name).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} </td>
                                          <td>{consultas.professional.user.name1 ? (consultas.professional.user.name1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} {consultas.professional.user.name2 ? (consultas.professional.user.name2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} {consultas.professional.user.lastname1 ? (consultas.professional.user.lastname1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} {consultas.professional.user.lastname2 ? (consultas.professional.user.lastname2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''}</td>
                                          <td> 
                                          <Moment format="YYYY/MM/DD HH:mm">
                                          {consultas.date}
                                          </Moment>
                                          </td>
                                          <td><CalificacionEstrellas valor={consultas.score}/></td>
                                          <td>{(consultas.status).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</td>
                                          {estado}
                                                   
                                        </tr>
                                
                                          )
                                        }else{

                                        }
                                         }
                                        )}
                                      
                                                        
                                      </tbody>
                                 
                                </table>
                          </div>

                                <div className="consultas-pagination-bar">
                                      <span className="consultas-pager-info">{this.state.pager_infoconsultas}</span>

                                      <nav className="nav consultas-pagination">

                                          <ul className="pagination">

                                              {this.state.Pager_Consultas.map(page_consulta=>{

                                                var activo=page_consulta.activo
                                                if(activo==true){
                                                  activo='page-item active'
                                                }else{
                                                  activo='page-item'
                                                }

                                               // alert(activo)

                                               return(

                                                       <li className={activo}>
                                                         <a className="nav-link" onClick={()=>{this.loadMoreDataconsultas(page_consulta)}}>{page_consulta.texto}</a>
                                                       </li>
                                                 )
                                                }
                                               )
                                              }
                                          </ul>

                                      </nav>
                                </div>

                          <div className="consultas-empty">
                          <div className="d-flex justify-content-center">
                                <div id="empty_page" className="estado-vacio__wrap"><EstadoVacio/></div>
                          </div>
                          <div className="d-flex justify-content-center">
                               <h5 id="text_page"> <b>No hay información que mostrar</b> </h5>
                          </div>
                          </div>

                        </div>

                        

                      </div>

                      <div className="tab-pane fade" id="consultas-tabs-informes" role="tabpanel" aria-labelledby="consultas-tabs-informes-tab">

                          <InformeConsultas ref={this.informeRef} />

                      </div>

                    </div>

                </div>

            </div>


            <div className="modal fade" id="modal-consulta">
                <div className="modal-dialog modal-lg">
                  <div className="modal-content consultas-respuesta-modal">
                    <div className="modal-header consultas-respuesta-modal__header">
                      <h4 className="modal-title consultas-respuesta-modal__title"><i className="fas fa-file-medical-alt"></i> Detalle de consulta</h4>
                      <button type="button" className="close consultas-respuesta-modal__close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>

                        <div className="modal-body consultas-respuesta-modal__body">

                            <h6 className="consultas-trazabilidad__titulo">Trazabilidad de la atención</h6>

                            <div className="consultas-trazabilidad">

                              <div className={`consultas-trazabilidad__paso${trazabilidad.asignada ? ' consultas-trazabilidad__paso--completo' : ''}`}>
                                <span className="consultas-trazabilidad__circulo"><i className="fas fa-calendar-check"></i></span>
                                <span className="consultas-trazabilidad__texto">Asignada</span>
                              </div>

                              <span className={`consultas-trazabilidad__linea${trazabilidad.finalizada ? ' consultas-trazabilidad__linea--completa' : ''}`}></span>

                              <div className={`consultas-trazabilidad__paso${trazabilidad.finalizada ? ' consultas-trazabilidad__paso--completo' : ''}`}>
                                <span className="consultas-trazabilidad__circulo"><i className="fas fa-flag-checkered"></i></span>
                                <span className="consultas-trazabilidad__texto">Finalizada</span>
                              </div>

                              <span className={`consultas-trazabilidad__linea${trazabilidad.conHistoria ? ' consultas-trazabilidad__linea--completa' : ''}`}></span>

                              <div className={`consultas-trazabilidad__paso${trazabilidad.conHistoria ? ' consultas-trazabilidad__paso--completo' : ''}`}>
                                <span className="consultas-trazabilidad__circulo"><i className="fas fa-file-medical"></i></span>
                                <span className="consultas-trazabilidad__texto">Con historia clínica</span>
                              </div>

                              <span className={`consultas-trazabilidad__linea${trazabilidad.conCargos ? ' consultas-trazabilidad__linea--completa' : ''}`}></span>

                              <div
                                className={`consultas-trazabilidad__paso${trazabilidad.conCargos ? ' consultas-trazabilidad__paso--completo' : ''}${trazabilidad.requiereCargo ? ' consultas-trazabilidad__paso--alerta' : ''}`}
                                onClick={trazabilidad.requiereCargo ? () => { window.location.href = "/facturacion" } : undefined}
                              >
                                <span className="consultas-trazabilidad__circulo">{trazabilidad.cargandoCargos ? <i className="fas fa-circle-notch fa-spin"></i> : <i className="fas fa-file-invoice-dollar"></i>}</span>
                                <span className="consultas-trazabilidad__texto">{trazabilidad.requiereCargo ? 'Realizar cargo' : 'Con cargos realizados'}</span>
                              </div>

                              <span className="consultas-trazabilidad__linea"></span>

                              <div className="consultas-trazabilidad__paso consultas-trazabilidad__paso--pendiente">
                                <span className="consultas-trazabilidad__circulo"><i className="fas fa-file-invoice"></i></span>
                                <span className="consultas-trazabilidad__texto">Facturada</span>
                              </div>

                            </div>

                            <div className="consultas-form-section">
                            <h6 className="consultas-form-section__titulo"><i className="fas fa-id-card"></i> Datos generales</h6>
                            <div className="row consultas-form-row">

                                <div className="col-md-2">
                                      <div className="form-group">
                                        <label >ID:</label>
                                        <input type="text" className="form-control" name="id_consulta" value={form.idconsulta} readOnly />
                                      </div>
                                </div>

                                <div className="col-md-4">
                                      <div className="form-group">
                                        <label >ID Paciente:</label>
                                        <input type="text" className="form-control" name="id_paciente" value={form.id_paciente} readOnly />
                                      </div>
                                </div>

                                <div className="col-md-6">
                                      <div className="form-group">
                                        <label >Paciente:</label>
                                        <input type="text" className="form-control" name="nom_paciente" value={form.nom_paciente + ' '+ form.nom2_paciente + ' '+ form.apell1_paciente + ' '+ form.apell2_paciente} readOnly />
                                      </div>
                                </div>

                            </div>

                            <div className="row consultas-form-row">

                                <div className="col-md-6">
                                    <div className="form-group">
                                            <label >Médico:</label>
                                            <input type="text" className="form-control" name="nom_medico" value={form.nom_medico + ' '+ form.nom2_medico + ' '+ form.apell1_medico + ' '+ form.apell2_medico} readOnly />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                            <label >EPS:</label>
                                            <input type="text" className="form-control" name="fechafin_edit" value={form.eps} readOnly/>
                                    </div>
                                </div>

                            </div>
                            </div>

                            <div className="consultas-form-section">
                            <h6 className="consultas-form-section__titulo"><i className="fas fa-notes-medical"></i> Historia clínica</h6>

                                  {this.state.Historia.map(histo=>{
                                     return(


                                          <div className="form-group">
                                                  <label >{histo.field}:</label>
                                                  <textarea className="form-control" rows="2" name="nom_medico" value={histo.value} readOnly> </textarea>
                                          </div>



                                        )
                                       }
                                     )
                                  }
                            </div>

                        </div>

                        <div className="modal-footer justify-content-between consultas-form-footer">
                              {/*<div className="btn-group dropright">
                                  <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled={!this.state.active_button}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Imprimir
                                          <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                                            <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                                            <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                                          </svg>
                                  </button>
                                  <div className="dropdown-menu">
                                    <a className="dropdown-item" href="#" onClick={()=> this.descargar_consulta()}>Historia clinica</a>
                                    <a className="dropdown-item" href="#" onClick={()=> this.descargar_formula()}>Formula médica</a>
                                    <a className="dropdown-item" href="#" onClick={()=> this.descargar_orden()}>Orden médica</a>
                                  </div>
                              </div>*/}
                              {/*<button type="button" className="btn btn-success" onClick={()=> this.saverecurso()}> Descargar video
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" class="bi bi-cloud-download" viewBox="0 0 16 16">
                                  <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"/>
                                </svg>
                              </button>*/}
                             <button type="button" className="btn btn-danger" data-dismiss="modal">Cerrar</button>
                        </div>

                  </div>
                 
                </div>
               
            </div>         


              <div className="modal fade" id="modal-loader" data-backdrop="static">
                <div className="modal-dialog modal-lg">
                  <div className="consultas-loader-modal">

                      <div class="d-flex justify-content-center">
                            {this.state.loading_recurso?false: <ReactBootStrap.Spinner animation="grow" variant="danger"/>}
                      </div>

                      <div class="d-flex justify-content-center">
                            <spam id="spamloader"> <h2>Descargando video</h2> </spam>
                      </div>

                  </div>
                </div>

              </div>


              <div className="modal fade" id="modal-infopcte" data-backdrop="static">
                <div className="modal-dialog modal-lg">
                  <div className="modal-content consultas-respuesta-modal">
                    <div className="modal-header consultas-respuesta-modal__header">
                      <h4 className="modal-title consultas-respuesta-modal__title"><i className="fas fa-user-injured"></i> Más información del paciente</h4>
                      <button type="button" className="close consultas-respuesta-modal__close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body consultas-respuesta-modal__body">

                          <div className="consultas-form-section">
                          <h6 className="consultas-form-section__titulo"><i className="fas fa-id-card"></i> Datos personales</h6>
                          <div className="row consultas-form-row">

                              <div className="col-md-3">
                                  <div className="form-group">
                                          <label >Fecha de nacimiento:</label>
                                          <input type="text" className="form-control" id="fecha_naci" name="fecha_naci" value={form.fecha_naci} readOnly/>
                                  </div>

                              </div>

                              <div className="col-md-2">
                                  <div className="form-group">
                                          <label >Edad:</label>
                                          <input type="text" className="form-control" id="edad_pcte" name="edad_pcte" value={form.edad_pcte} readOnly/>
                                  </div>

                              </div>

                              <div className="col-md-1">

                                  <div className="form-group">
                                          <label >Género:</label>
                                          <input type="text"  className="form-control" id="genero_pcte" name="genero_pcte" value={form.genero_pcte} readOnly/>
                                  </div>

                              </div>

                              <div className="col-md-3">
                                  <div className="form-group">
                                          <label >Teléfono:</label>
                                          <input type="text" className="form-control" id="tel_pcte" name="tel_pcte" value={form.tel_pcte} readOnly/>
                                  </div>

                              </div>

                              <div className="col-md-3">

                                  <div className="form-group">
                                          <label >Dirección:</label>
                                          <input type="text"  className="form-control" id="dir_pcte" name="dir_pcte" value={form.dir_pcte} readOnly/>
                                  </div>

                              </div>

                          </div>
                          </div>

                          <div className="consultas-form-section">
                          <h6 className="consultas-form-section__titulo"><i className="fas fa-map-marker-alt"></i> Ubicación</h6>
                          <div className="row consultas-form-row">

                              <div className="col-md-6">

                                  <div className="form-group">
                                          <label >Municipio:</label>
                                          <input type="text" className="form-control" id="municipio_pcte" name="municipio_pcte" value={form.municipio_pcte} readOnly/>
                                  </div>

                              </div>

                              <div className="col-md-6">

                                  <div className="form-group">
                                          <label >Departamento:</label>
                                          <input type="text" className="form-control" id="departamento_pct" name="departamento_pct" value={form.departamento_pct} readOnly/>
                                  </div>

                              </div>

                          </div>
                          </div>

                          <div className="consultas-form-section">
                          <h6 className="consultas-form-section__titulo"><i className="fas fa-notes-medical"></i> Datos de salud</h6>
                          <div className="row consultas-form-row">

                              <div className="col-md-6">

                                  <div className="form-group">
                                          <label >EPS:</label>
                                          <input type="text" className="form-control" id="eps_pcte" name="eps_pcte" value={form.eps_pcte} readOnly/>
                                  </div>

                              </div>

                              <div className="col-md-6">

                                  <div className="form-group">
                                          <label >Régimen:</label>
                                          <input type="text" className="form-control" id="regimen_pcte" name="regimen_pcte" value={form.regimen_pcte} readOnly/>
                                  </div>

                              </div>

                          </div>
                          </div>

                          <div className="consultas-form-section">
                          <h6 className="consultas-form-section__titulo"><i className="fas fa-user-friends"></i> Persona responsable</h6>
                          <div className="row consultas-form-row">

                              <div className="col-md-6">

                                  <div className="form-group">
                                          <label >Persona responsable:</label>
                                          <input type="text" className="form-control" id="responsable_pcte" name="responsable_pcte" value={form.responsable_pcte} readOnly/>
                                  </div>

                              </div>

                              <div className="col-md-3">

                                  <div className="form-group">
                                          <label >Teléfono:</label>
                                          <input type="text" className="form-control" id="telresponsable_pcte" name="telresponsable_pcte" value={form.telresponsable_pcte} readOnly/>
                                  </div>

                              </div>

                              <div className="col-md-3">

                                  <div className="form-group">
                                          <label >Parentesco:</label>
                                          <input type="text" className="form-control" id="parentescoresp_pcte" name="regimeparentescoresp_pcten_pcte" value={form.parentescoresp_pcte} readOnly/>
                                  </div>

                              </div>

                          </div>
                          </div>

                          <div className="consultas-form-section">
                          <h6 className="consultas-form-section__titulo"><i className="fas fa-envelope"></i> Contacto</h6>
                          <div className="row consultas-form-row">

                              <div className="col-md-6">

                                  <div className="form-group">
                                          <label >Correo eletrónico:</label>
                                          <input type="text" className="form-control" id="email_pcte" name="email_pcte" value={form.email_pcte} readOnly/>
                                  </div>

                              </div>

                          </div>
                          </div>

                    </div>
                  
                  </div>
                  {/* /.modal-content */}
                </div>
                {/* /.modal-dialog */}
              </div>


              <div className="modal fade" id="modal-crearhc" data-backdrop="static">
              <div className="modal-dialog modal-lg">
                <div className="modal-content consultas-respuesta-modal">
                  <div className="modal-header consultas-respuesta-modal__header">
                    <h4 className="modal-title consultas-respuesta-modal__title"><i className="fas fa-file-medical"></i> Crear formato de historia clínica por especialidad</h4>
                    <button type="button" className="close consultas-respuesta-modal__close" data-dismiss="modal" aria-label="Close" onClick={()=> this.Limpiar_form()}>
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body consultas-respuesta-modal__body">

                      <div className="consultas-form-section">
                      <h6 className="consultas-form-section__titulo"><i className="fas fa-user-md"></i> Especialidad y convenio</h6>
                      <div className="row consultas-form-row">

                          <div className="col-md-6">
                                <div className="form-group">
                                          <label >Especialidad:</label>
                                          <select className="form-control" id="id_espe" name="id_espe" >
                                                <option  value="null"> Seleccione...</option>
                                                <option  value="0"> Ginecología</option>
                                                <option  value="0"> Medicina interna</option>
                                                <option  value="0"> Pediatría</option>

                                          </select>
                                  </div>
                          </div>

                          <div className="col-md-6">
                                <div className="form-group">
                                          <label >Convenio:</label>
                                          <select  className="form-control" id="id_convenio" name="id_convenio" >
                                                <option  value="null"> Seleccione...</option>


                                          </select>
                                  </div>
                          </div>

                      </div>
                      </div>

                      <div className="consultas-form-section">
                      <h6 className="consultas-form-section__titulo"><i className="fas fa-list-alt"></i> Nombre y tipo de campo</h6>
                      <div className="row consultas-form-row">

                            <div className="col-md-6">

                                  <div className="form-group">                    
                                            <label >Nombre del campo:</label>
                                            <div className="input-group">

                                                <input type="text" maxLength="10" className="form-control" id="cod_servi" name="cod_servi" autoComplete='nope' value={form.cod_servi} onChange={this.handleChange}/>                       

                                            </div>
                                  </div>
          
                            </div>   

                            <div className="col-md-6">
                                <div className="form-group">                    
                                          <label >Tipo de campo:</label>
                                          <select className="form-control" onChange={this.GetTipocampo} id="tipo_campo" name="id_espe" >
                                                <option  value="null"> Seleccione...</option>
                                                <option  value="1"> input</option>
                                                <option  value="2"> select</option> 
                                                <option  value="3"> textarea</option>
                                                <option  value="4"> date</option>
                                                                 
                                          </select>                     
                                  </div>
                                  
                            </div>


                      </div>
                      </div>

                      {/* <div className="row" id="select_especialidad">
                                        
                                        <div className="col-md-12">
                                            <div className="form-group">                    
                                                    <label >Especialidad:</label>
                                                    <Especialidad handleridespe={this.handleridespe} />
                                            </div>
                        
                                        </div>
                                        
                        
                      </div> */}
        
                      

                      <div className="consultas-form-section">
                      <h6 className="consultas-form-section__titulo"><i className="fas fa-sliders-h"></i> Valor del campo</h6>

                      <div className="row" id="row_input">

                            <div className="col-md-12">
                                <div className="form-group">                    
                                        <label >Input:</label>
                                        <div className="input-group"> 

                                            <input type="text" maxLength="10" className="form-control camponum" id="dato_input" name="dato_input" autoComplete='nope' value={form.valor_servi}  onChange={this.handleChange} /> 

                                        </div>
                                </div>
            
                            </div>          
            
                      </div>

                       <div className="row" id="row_select">              
                                        
                            <div className="col-md-12">
                                <div className="form-group">                    
                                          <label >Select:</label>
                                          <select className="form-control" id="tipo_campo" name="id_espe" >
                                                <option  value="null"> Valores...</option>
                                                
                                                                 
                                          </select>                     
                                  </div>
                            </div>          
            
                      </div>   

                      <div className="row" id="row_textarea">
        
                          <div className="col-md-12">
        
                                <div className="form-group">                    
                                    <label >Textarea:</label>                           
                                    <textarea class="form-control" rows="3" id="dato_textarea" name="dato_textarea" autoComplete='nope' value={form.descrip} onChange={this.handleChange} ></textarea>
                                    
                                </div>
        
                          </div>
        
                      </div> 

                      <div className="row" id="row_date">              
                                        
                            <div className="col-md-12">
                                <div className="form-group">                    
                                        <label >Date:</label>
                                        <div className="input-group"> 

                                            <input type="date"  className="form-control camponum" id="dato_date" name="dato_date" autoComplete='nope' value={form.valor_servi}  onChange={this.handleChange} /> 

                                        </div>
                                </div>
            
                            </div>          
            
                      </div>

                      </div>

                  </div>
                  <div className="modal-footer justify-content-between consultas-form-footer">
                    <button type="button" className="btn btn-primary" disabled={!this.state.active_button} > {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Guardar formato</button>
                    <button type="button" className="btn btn-danger" data-dismiss="modal" >Cerrar</button>
                  </div>
                </div>
               
              </div>
             
            </div>





        </div>

        </div>


    )

  }
  
}



export default Consultas_programada;